import type { ChainConfigMap } from "./types"

export const chainNames = ["rujira"] as const

export interface TvEndpoint {
  url: string
  type: "benchmarks"
  sleep_rate_limit_ms: number
}

export const tradingViewHistoryEndpoints: TvEndpoint[] = [
  {
    url: "https://benchmarks.pyth.network/v1/shims/tradingview/history",
    type: "benchmarks",
    sleep_rate_limit_ms: 3000,
  },
]

export const chainConfigMap: ChainConfigMap = {
  "rujira-devnet": {
    rpcUrl: "http://rpc-devnet.starsquid.io",
    restUrl: "http://api-devnet.starsquid.io",
    network: "testnet",
    lowGasPrice: "0.025",
    averageGasPrice: "0.03",
    highGasPrice: "0.035",
    chainId: "thorchain",
    addressPrefix: "tthor",
    chainPrettyName: "Rujira",
    asset: {
      base: "rune",
      display: "rune",
      symbol: "RUNE",
    },
  },
  "rujira-testnet": {
    rpcUrl: "https://stagenet-rpc.ninerealms.com",
    restUrl: "https://stagenet-thornode.ninerealms.com",
    network: "testnet",
    lowGasPrice: "0.025",
    averageGasPrice: "0.03",
    highGasPrice: "0.035",
    chainId: "thorchain-stagenet-2",
    addressPrefix: "sthor",
    chainPrettyName: "Rujira",
    asset: {
      base: "rune",
      display: "rune",
      symbol: "RUNE",
    },
  },
  "rujira-mainnet": {
    rpcUrl: "https://gateway.liquify.com/chain/thorchain_rpc",
    restUrl: "https://gateway.liquify.com/chain/thorchain_api",
    network: "mainnet",
    lowGasPrice: "0.025",
    averageGasPrice: "0.03",
    highGasPrice: "0.035",
    chainId: "thorchain-1",
    addressPrefix: "thor",
    chainPrettyName: "Rujira",
    asset: {
      base: "rune",
      display: "rune",
      symbol: "RUNE",
    },
  },
}
